module.exports = __webpack_public_path__ + "img/Feature.f742f259.png";